  <!-- empty list div start -->
  <div class="mt-3" *ngIf="(suggestionLength==0)">
    <div class="p-3 text-center">
      <img src="assets/themes/icons/no-connection.svg" alt="no data found">
      <h6 class="mb-1 heading-4 pt-3">
        <span class="color-grey-500">{{mls.languageText.connection_suggestion_list.key2}}</span>
        <span *ngIf="mls?.is_lskey_display==1">(connection_suggestion_list.key2)</span>
      </h6>
      <p class="mb-1">
        <span class="color-grey-500">{{mls.languageText.connection_suggestion_list.key3}}</span>
        <span *ngIf="mls?.is_lskey_display==1">(connection_suggestion_list.key3)</span>
      </p>
    </div>
  </div>
  <br *ngIf="suggestionLength==0">
  <!-- empty list div end -->
  <!-- empty list div start -->
  <div *ngIf="(len==0)" class="mt-3">
    <div class="p-3 text-center">
      <img src="assets/themes/icons/no-connection.svg" alt="no data found">
      <h6 class="mb-1 heading-4 pt-3">
        <span class="color-grey-500">{{mls.languageText.connection_request_list.key1}}</span>
        <span *ngIf="mls?.is_lskey_display==1">(connection_request_list.key1)</span>
      </h6>
      <p class="mb-1">
        <span class="color-grey-500">{{mls.languageText.connection_request_list.key2}}</span>
        <span *ngIf="mls?.is_lskey_display==1">(connection_request_list.key2)</span>
      </p>
    </div>
  </div>
  <!-- connection request -->
  <div *ngIf="total_connection_request >=0" class="mt-3">
    <div class="mb-3" *ngIf="total_connection_request>=0">
      <div class="row">
        <div class="col-12">
          <p class="d-flex align-items-center">
            <span class="heading-4">
              <span class="color-grey-700">{{request_header.header}}</span></span>
              <span *ngIf="total_connection_request !=0" class="ml-3 chip small filled error">
                {{total_connection_request}}
              </span>
          </p>
        </div>
      </div>
    </div>
 <!-- connection list -->
    <div>     
      <div *ngFor="let suggObj of connectionRequestData; let index=index">
        <div class="py-3 px-3 mb-3 connection-card" *ngIf="index < limit || limit ==undefined">
          <app-connection-card [callingfrom]="screenName" [usercardsize]="'s'" 
            *ngIf="index < limit || limit ==undefined" [suggObj]="suggObj" (resetSuggList)=resetSuggList($event)>
          </app-connection-card>
        </div>
      </div>
      <div class="text-center button pb-2" *ngIf=" (this.total_connection_request >limit)">
        <span (click)="navigateTo('connection/request')" class="cursor-pointer">
          <span class="mr-1">{{request_header.view_more_text}}</span>
          <!-- <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.229699 0.814415C0.424961 0.619153 0.741543 0.619153 0.936805 0.814415L5.77014 5.64775C5.9654 5.84301 5.9654 6.15959 5.77014 6.35486L0.936805 11.1882C0.741543 11.3835 0.424961 11.3835 0.229699 11.1882C0.0344364 10.9929 0.0344364 10.6763 0.229699 10.4811L4.70948 6.0013L0.229699 1.52152C0.0344364 1.32626 0.0344364 1.00968 0.229699 0.814415Z" fill="#1D1919"/>
            </svg> -->
            <img src="assets/themes/icons/right-arorrow.svg" width="16" alt="arrow icon">
            
        </span>
      </div>
      <div *ngIf="(finished && Connoffset!=0 && (limit==undefined || this.total_connection_request <limit))"
        class="text-center pb-2" (click)="sentRequestviewmore()">
        <span class="button">{{mls.languageText.connection_request_list.key2}}</span>
        <span class="button"
          *ngIf="mls?.is_lskey_display==1">(connection_request_list.key2)</span>
      </div>
      <!-- end connection list -->
    </div>
  </div>

  <!--Loaders for suggestion-->
  <div *ngIf="(!finished && offset==1 && masterService.isOnline==true && connSuggLoader === false)" class="">
    <div class='text-center'>
      <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post" />
    </div>
  </div>
  <!--EOf Loaders-->

  <div *ngIf="suggestionLength>=1" class="my-3">
    <div>
      <div class="row">
        <div class="col-12">
          <p class="heading-4">
            <span class="color-grey-700">{{suggestion_header.header}}</span>
          </p>
        </div>
      </div>
    </div>

    <app-connection-sugg-filter [suggestionFilter]="suggestionFilter" [filterIndex]="filterIndex"
      (connectionFilter)="applySuggestionFilter($event)">
    </app-connection-sugg-filter>

    <div id="timelineView" infiniteScroll [infiniteScrollDistance]="numbers.TWO"
      [infiniteScrollThrottle]="numbers.FIFTY" [infiniteScrollDisabled]="busyGettingData" (scrolled)="onScrollDown()" [scrollWindow]="true">
      <!-- suggestion  list -->
      <div class="py-3 px-3 mb-3 connection-card" *ngFor="let suggObj of suggestionData; let index=index">
        <app-connection-card [usercardsize]="'m'" [callingfrom]="screenName" [suggObj]="suggObj"
          (resetSuggList)=resetSuggList($event)>
        </app-connection-card>
      </div>
      <div *ngIf="(finishedsug && suggestionData.length === 0)" class="text-center p-5">
        <img src="assets/themes/icons/no-search-result.svg" />
        <h6 class="pt-3">
          {{mls.languageText.connection_request_list.key5}}
        </h6>
        <p class="p-2">
          {{mls.languageText.connection_request_list.key6}}
        </p>
      </div>
      <div *ngIf="!finished && offset!=0 && masterService.isOnline==true" class='text-center'>
        <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post" />
      </div>
    </div>
  </div>

  <!--Loaders for suggestion-->
  <div *ngIf="!finishedsug && offset==1 && masterService.isOnline==true && connSuggLoader === false">
    <div class='text-center'>
      <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post" />
    </div>
  </div><br *ngIf="!finishedsug">
  <!--EOf Loaders-->

  <app-info-modal (resetInfoModal)=resetInfoModal() [isInfoModalShown]=isInfoModalShown [info_msg]=info_msg>
  </app-info-modal>